import React from 'react';
import './cepcidocs.css';

const PdfViewer = () => {
  const isMobile = window.innerWidth <= 768; 

  return (
    <div align='center' className="pdf-viewer-container">
      <h2 className="pdf-viewer-title">Procedimiento y Protocolo Para la Recepción de Denuncias del Comité de Ética y Prevención de Conflictos de Interés</h2>
      {isMobile ? (
       
        <div className="pdf-viewer-mobile">
          <a
            href={`https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/cepci/2023/Proc_Prot_Rec_Atn_Denun..pdf`}
            download
            className="pdf-viewer-download"
          >
            Descargar PDF
          </a>
        </div>
      ) : (
        // Si no es un dispositivo móvil, mostrar el visor de PDF en un iframe
        <div className="pdf-viewer-wrapper">
          <iframe
            src={`https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/cepci/2023/Proc_Prot_Rec_Atn_Denun..pdf`}
            title="Visor de PDF"
            className="pdf-viewer-iframe"
          ></iframe>
        </div>
      )}
    </div>
  );
};

export default PdfViewer;